import styled from '@emotion/styled/macro'
import { ResourceCategoryContext } from 'context'
import { themeColor } from 'mixins'
import { Pivot, PivotItem, PivotLinkFormat } from 'office-ui-fabric-react'
import * as React from 'react'
import { useTranslation } from 'react-i18next'

const CategoryPivot = styled(Pivot)`
  .ms-Pivot {
    display: flex;
    flex-wrap: wrap;
    justify-content: stretch;

    background: ${themeColor('neutralLight')};
  }

  .ms-Pivot-link {
    /* flex: 1; */

    .ms-Button-flexContainer {
      justify-content: center;
    }
  }
`
const TypePivot = styled(Pivot)`
  margin: 0 4px;
`

export interface ResourceCategoryPaginationProps {
  selection: { category: string; type: string }
  onChange: (selection: { category: string; type: string }) => void
  onResetFiltering: () => void
}
function compareLodgingTypes(
  a: { id: string; title: string },
  b: { id: string; title: string }
) {
  const lodgingOrder = [
    'ownedHouse',
    'rentedHouse',
    'accomodation',
    'hotel',
    'room',
  ]
  const firstItemIndex = lodgingOrder.indexOf(a.id)
  const secondItemIndex = lodgingOrder.indexOf(b.id)
  if (firstItemIndex < secondItemIndex) {
    return -1
  }
  if (firstItemIndex > secondItemIndex) {
    return 1
  }
  return 0
}

export const ResourceCategoryPagination: React.FunctionComponent<
  ResourceCategoryPaginationProps
> = ({ selection, onChange, onResetFiltering }) => {
  const { t } = useTranslation()
  const items = React.useContext(ResourceCategoryContext)
  const selectedCategory =
    items.filter((x) => x.id === selection.category)[0] || items[0]
  return (
    <>
      <CategoryPivot
        headersOnly={true}
        linkFormat={PivotLinkFormat.tabs}
        selectedKey={selectedCategory.id}
        onLinkClick={(item) => {
          onResetFiltering()
          const category = items.filter((x) => x.id === item!.props.itemKey)[0]

          if (category) {
            onChange({
              category: category.id,
              type: 'all',
            })
          }
        }}
      >
        {items.map(({ id, title }) => (
          <PivotItem key={id} itemKey={id} headerText={title} />
        ))}
      </CategoryPivot>
      <TypePivot
        headersOnly={true}
        linkFormat={PivotLinkFormat.links}
        selectedKey={selection.type}
        onLinkClick={(item) => {
          onResetFiltering()
          onChange({
            category: selection.category,
            type: item!.props.itemKey!,
          })
        }}
      >
        {selectedCategory.types
          .sort(compareLodgingTypes)
          .map(({ id, title }) => (
            <PivotItem key={id} itemKey={id} headerText={title} />
          ))}
        <PivotItem key="all" itemKey="all" headerText={t('field.type.all')} />
      </TypePivot>
    </>
  )
}
